module.exports = __webpack_public_path__ + "img/product_91.671a37a.webp";